import { render, staticRenderFns } from "./type-modal.vue?vue&type=template&id=4f0537f4&scoped=true&"
import script from "./type-modal.vue?vue&type=script&lang=js&"
export * from "./type-modal.vue?vue&type=script&lang=js&"
import style0 from "./type-modal.vue?vue&type=style&index=0&id=4f0537f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0537f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f0537f4')) {
      api.createRecord('4f0537f4', component.options)
    } else {
      api.reload('4f0537f4', component.options)
    }
    module.hot.accept("./type-modal.vue?vue&type=template&id=4f0537f4&scoped=true&", function () {
      api.rerender('4f0537f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/load-types/type-modal.vue"
export default component.exports